var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",attrs:{"id":"page-login"}},[_c('div',{staticClass:"vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"},[_c('vx-card',[_c('div',{staticClass:"full-page-bg-color",attrs:{"slot":"no-body"},slot:"no-body"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }